import { render, staticRenderFns } from "./StatusDetail.vue?vue&type=template&id=7420a046"
import script from "./StatusDetail.vue?vue&type=script&lang=js"
export * from "./StatusDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports